function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M500.5,404.6l-79.1-79.1c-15.7-15.7-41.8-15.2-58.1,1.1l-39.8,39.8c-2.5-1.4-5.1-2.8-7.9-4.4 c-25.2-13.9-59.6-33-95.8-69.3c-36.3-36.3-55.5-70.8-69.4-96c-1.5-2.7-2.9-5.2-4.3-7.7l26.7-26.7l13.1-13.2 c16.3-16.3,16.8-42.4,1.1-58.1L108,12.1C92.2-3.7,66.1-3.2,49.8,13.1L27.5,35.6l0.6,0.6c-7.5,9.5-13.7,20.5-18.4,32.4 c-4.3,11.3-7,22.1-8.2,32.9c-10.4,86.6,29.1,165.7,136.5,273C286.5,522.8,406,511.6,411.2,511c11.2-1.3,22-4,32.9-8.3 c11.8-4.6,22.7-10.8,32.3-18.3l0.5,0.4l22.6-22.1C515.8,446.5,516.2,420.4,500.5,404.6z"
})))));

var SvgIconPhone = function SvgIconPhone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "15px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-phone.f0ee2860.svg";
export { ForwardRef as ReactComponent };